import styled from 'styled-components/macro';
import { imageBg } from 'styling/fast';

export const ButtonImgWrapper = styled.button`
  width: auto;
  border: 0;
  height: auto;
  font-size: 2.4rem;
  padding: 1rem 4rem;
  color: white;
  border-radius: 1rem;
  font-weight: 600;
  cursor: pointer;
  background-image: url('/image/other/btn-claim.png');
  opacity: 0.9;
  transition: all 0.5s;
  ${imageBg}
  :hover {
    opacity: 1;
  }
  :disabled {
    color: white;
    cursor: not-allowed;
    opacity: 0.5;
  }
  :disabled:hover {
  }
`;
